const dateDisplaySettings = {
  locales: 'en-US',
  options: { year: 'numeric', month: 'long', day: 'numeric' }
}
export { dateDisplaySettings }
